const CertificationStatus = [
  { value: 1, name: 'Uncertified', description: 'Uncertified' },
  { value: 2, name: 'Fatca', description: 'FATCA' },
  { value: 3, name: 'Chapter61', description: 'Chapter 61' },
  { value: 4, name: 'Nra', description: 'NRA' },
  { value: 5, name: 'CRS', description: 'CRS' },
  { value: 6, name: 'ExpiredFatca', description: 'FATCA Expired' },
  { value: 7, name: 'ExpiredChapter61', description: 'Chapter 61 Expired' },
  { value: 8, name: 'ExpiredNra', description: 'NRA Expired' },
  { value: 9, name: 'ExpiredCRS', description: 'CRS Expired' },
  { value: 10, name: 'Carf', description: 'CARF' },
  { value: 11, name: 'ExpiredCarf', description: 'CARF Expired' },
];

export default CertificationStatus;
